import { SVGProps } from 'react';

export const SearchLoupeQuestion = ({
  width = '32',
  height = '32',
  fill = 'none',
  ...otherProps
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill={fill}
    viewBox='0 0 32 32'
    {...otherProps}
  >
    <path
      stroke='#BDBDBD'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      d='M15.288 19.79a.2.2 0 1 0 .201.2.2.2 0 0 0-.201-.2'
    ></path>
    <path
      stroke='#BDBDBD'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      d='M15.29 16.672v-.276c0-.904.558-1.393 1.118-1.77.547-.367 1.095-.847 1.095-1.732a2.212 2.212 0 1 0-4.425-.001m13.589 13.774-4.334-4.334m-7.044 2.913c-5.498 0-9.956-4.458-9.956-9.956 0-5.5 4.458-9.956 9.956-9.956 5.499 0 9.956 4.457 9.956 9.956s-4.457 9.956-9.956 9.956'
    ></path>
  </svg>
);
